(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  if (!customElements.get('product-modal')) customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sums-carousel"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('DOMContentLoaded', function () {
  const carouselEl = document.querySelector('[data-component="product-carousel"] .swiper-container');

  if (carouselEl) {
    new Swiper(carouselEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      breakpoints: {
        768: {
          slidesPerView: 4,
        }
      },
      navigation: {
        nextEl: '[data-component="product-carousel"] .carousel-next',
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sums-home-image-carousel"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const carouselEl = document.querySelector('[data-component="home-image-carousel"] .swiper-container');

    if (carouselEl) {
      const arrowPolygon = document.querySelector(
        '[data-component="home-image-carousel"] .sums-home-image-carousel-next polygon'
      );

      const colorMap = {
        red: '#ff4f00',
        yellow: '#fae814',
        blue: '#0000ff',
        black: '#1a262b',
        cream: '#fffae5',
      };

      function updateArrowColor(swiperInstance) {
        const realIndex = swiperInstance.realIndex;
        const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
        const arrowColour = activeSlide.getAttribute('data-arrow-colour');
        const fillColor = colorMap[arrowColour] || '#FF4F00';

        if (arrowPolygon) {
          arrowPolygon.setAttribute('fill', fillColor);
        }
      }

     function updateTitle(swiper) {
  const activeSlide = swiper.slides[swiper.activeIndex];
  const title = activeSlide.getAttribute('data-title');
  const colour = activeSlide.getAttribute('data-colour');

  const titleWrapper = document.getElementById('carousel-title-wrapper');
  const titleEl = document.getElementById('carousel-title');

  // Update text
  titleEl.textContent = title;

  // Remove any previous colour classes
  titleWrapper.classList.remove('text-red', 'text-yellow', 'text-blue', 'text-black', 'text-cream');

  // Add the new colour class
  titleWrapper.classList.add(`text-${colour}`);
}


      const swiper = new Swiper(carouselEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        effect: 'fade',
        fadeEffect: {
          crossFade: true,
        },
        navigation: {
          nextEl: '[data-component="home-image-carousel"] .sums-home-image-carousel-next',
        },
        on: {
          init: function () {
            updateArrowColor(this);
             updateTitle(this);
          },
          slideChange: function () {
            updateArrowColor(this);
            updateTitle(this);
          },
        },
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
